import BigNumber from 'bignumber.js'

export const truncateNumber = (source: number, decimals: number = 2): number => {
  return new BigNumber(source).dp(decimals, 1).toNumber()
}
